module.exports = __webpack_public_path__ + "media/images/yt_thumbnail-1b4e1204a13014009b5616285582ca82.jpg";